import { Breadcrumb, Col, Menu, Row } from "antd"
import React, { memo, useEffect, useMemo, useState } from "react"
import { Outlet, useMatch, useNavigate } from "react-router"
import styles from './index.module.less';
import { getEquipmentById, OrganizationEquipmentService } from "@/services/project/equipment/equipment.service"
import { useRequest } from "ahooks"

interface EquipmentItemProps {
  orgId?: number
}

const equipmentMenus = [
  {
    key: 'basic',
    label: 'Basic Information',
  },
  {
    key: 'graph-design',
    label: 'Graph Design',
  },
  // {
  //   key: 'documents',
  //   label: 'Documents',
  // },
]

export const EquipmentItem = memo((props: EquipmentItemProps) => {
  const { orgId } = props
  const navigate = useNavigate()
  const adminMatch = useMatch('/admin/equipment/:id/:key')
  const orgMatch = useMatch('/:orgId/equipment/equipment/:id/:key')
  const match = orgId ? orgMatch : adminMatch
  
  const activeKey = useMemo(() => match?.params.key || '', [match])
  const equipmentId = match?.params.id
  
  const { data: equipment, refresh } = useRequest(() => {
    if (orgId) {
      return OrganizationEquipmentService.getEquipment(Number(equipmentId))
    }
    return getEquipmentById(Number(equipmentId))
  })
  
  if (!equipment) return null


  return <div>
    <Breadcrumb>
      <Breadcrumb.Item key={'list'}>Equipment List</Breadcrumb.Item>
      <Breadcrumb.Item key={'create'}>{equipment?.name}</Breadcrumb.Item>
    </Breadcrumb>
    <Row className={styles.equipmentBody}>
      <Col>
        <Menu
          activeKey={activeKey}
          items={equipmentMenus}
          onSelect={({ key }) => {
            navigate(key)
          }}
        />
      </Col>
      <Col className={styles.contentContainer} flex='auto'>
        <Outlet context={[equipment, refresh]} />
      </Col>
      
    </Row>
  </div>
})